import React, { Component } from 'react';

import './select.css';

class Select extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open : false,
            selected_item : { id:0, text:this.props.placeholder },
            highlighted_item : -1,
            options: this.props.options
        };

        this.handleClick        = this.handleClick.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleKeyUp        = this.handleKeyUp.bind(this);
        this.handleOptionClick  = this.handleOptionClick.bind(this);
        this.getSelectedByText  = this.getSelectedByText.bind(this);
        this.getSelectedById    = this.getSelectedById.bind(this);
    }

    componentDidUpdate(prevProps){
        if(!this.isEquivalent(prevProps.options, this.props.options)){
            this.setState({options: this.props.options, selected_item : { id:0, text:this.props.placeholder }});
        }
    }

    isEquivalent(a, b) {
        let aProps = Object.getOwnPropertyNames(a);
        let bProps = Object.getOwnPropertyNames(b);

        if (aProps.length !== bProps.length) {
            return false;
        }

        for (let i = 0; i < aProps.length; i++) {
            let propName = aProps[i];

            if (a[propName].text !== b[propName].text) {
                return false;
            }
        }

        return true;
    }

    handleClick(event) {

        //prevent form submission
        event.preventDefault();

        //fix for enter keyup event triggering click events - 0 = Enter key, 1 = click event
        if (!(event.detail === 0)) {
            let newState = !this.state.open;
            this.setState({open: newState});
        }
    }

    handleClickOutside() {
        this.setState({open: false});
    }

    handleKeyUp(event) {
        let highlighted_item = this.state.highlighted_item;
        let selected_item    = this.state.selected_item;

        switch(event.key) {
            case('ArrowDown'): (highlighted_item + 1) > this.state.options.length -1 ?
                                    highlighted_item = 0
                                   :  highlighted_item++;
                               this.setState({highlighted_item: highlighted_item});
                               break;

            case('ArrowUp'):   (highlighted_item - 1) < 0 ?
                                    highlighted_item = this.state.options.length -1
                                   :  highlighted_item--;
                               this.setState({highlighted_item: highlighted_item});
                               break;

            case('Enter'):     if(this.state.open === false)
                                    {this.setState({open: true})}
                               else
                                    {selected_item = this.state.options[highlighted_item];
                                    this.setState({highlighted_item: -1, selected_item: selected_item, open: false})}
                               break;

            case('Escape'):    this.setState({highlighted_item: 0, open: false});
                               break;
            default:           break;

        }
    }

    handleOptionClick(event) {
        event.stopPropagation();
        event.preventDefault();

        let selected_item = null;



        if(event.target.tagName === 'SELECT') {
            selected_item = this.getSelectedByText(event.target.value);
        } else {
            selected_item = this.getSelectedById(event.target.id);
        }

        this.setState({selected_item : selected_item, open: false});
        this.props.onChange(selected_item.id);
    }

    getSelectedByText(text) {
        let selected_item  = this.state.options.find((item) => {
            return item.text === text;
        })
        return selected_item;
    }

    getSelectedById(id) {
        let selected_item  = this.state.options.find((item) => {
            return parseInt(item.id) === parseInt(id, 10);
        });
        return selected_item;
    }


    render() {
        const {
            deviceState = 'mobile',
            label      = '',
            disabled   = false,
            tabIndex,
            arrow= false,
            className = ''} = this.props;

        let content       = null;
        let activeClass   = '';
        let disabledClass = '';
        const options     = this.props.options;

        if(this.state.open) { activeClass = 'active' }
        if(this.props.disabled) { disabledClass = 'disabled' }

        //responsive conditional markup - renders a regular select when on mobile/tablet
        if (deviceState === 'desktop') {

            content = <div className='input_wrapper'>
                {label !== '' && <label> {label}:</label>}
                <div className={'select_wrapper ' + activeClass + (disabled ? ' disabled' : '')}
                     tabIndex={tabIndex}
                     onBlur={this.handleClickOutside}
                     onKeyUp={this.handleKeyUp}>

                    <button className={"select_button " + disabledClass}
                            aria-label="פתח תפריט בחירה"
                            onClick={this.handleClick}
                            type='button'>
                        {this.state.selected_item.text}
                        {arrow && <img src={arrow} alt='/'/>}
                    </button>

                    <ul className='dropdown_menu'>
                        {options.map((item, index) => {

                            let activeOption = '';
                            let hightlightedOption = '';
                            let disabled = '';
                            let title = '';

                            if (item.id === this.state.selected_item.id) {
                                activeOption = 'active'
                            }

                            if (index === this.state.highlighted_item) {
                                hightlightedOption = ' highlight'
                            }

                            if (item.disabled === true){
                                disabled = ' disabled';
                            }

                            if (item.title === true){
                                title = ' title';
                            }

                            return <li className={"select_option " + activeOption + hightlightedOption + disabled + title}
                                       key={index}
                                       id={item.id}
                                       onMouseDown={this.handleOptionClick}>
                                {item.text}
                            </li>
                        })}
                    </ul>
                </div>
            </div>
        } else {

            content = <div className='input_wrapper'>
                {label !== '' && <label> {label}:</label>}
                <select tabIndex={tabIndex}
                        value={this.state.selected_item.text}
                        onChange={this.handleOptionClick}>
                    <option disabled> {this.state.selected_item.text} </option>
                    {options.map((item, index) => {
                        return <option key={index}> {item.text} </option>
                    })}
                </select>
            </div>
        }

        return (
            <div className = {"select " + className}>
                { content }
            </div>
        )
    }
}
export default Select;


